<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h2 v-if="pd_exists" class="text-h2 mb-0">{{num +' ' + title}}</h2>
    </template>

    <template v-slot:leftPanel>
      <!--Reading Options Card-->
      <LangOpts
        :options="['en', 'tc']"
        :curLang="$route.params.lang"
        @go_trans="go_trans($event)"
      />
    </template>

    <template v-slot:mainPanel>
      <v-divider></v-divider>
      <div v-if="pd_exists" class="pd-content mb-16" v-html="show_hl&&$route.query.hl?content_hl:content" @click="content_clicked"></div>
      <v-alert v-else-if="!overlay"
        dense text
        type="error"
        class="mt-3 mb-4"
        icon="mdi-alert-outline"
        > 
          {{$t('error.page_unavailable')}}
      </v-alert>
      <!--loading overlay-->
      <v-overlay :value="overlay">
        <v-progress-circular
        indeterminate
        size="64"
        ></v-progress-circular>
      </v-overlay>
    </template>

  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import LangOpts from '../components/LangOpts'
  import DownloadWidget from '../components/DownloadWidget'
  import api from '@/scripts/api'
  import scrollhelper from '@/scripts/scrollhelper'
  import highlighthelper from '@/scripts/highlighthelper'
  export default {
    name: 'PD',
    data(){
      return {
        overlay: false,
        pd_exists: false,
        num: '',
        title: '',
        show_hl: true,
        content: '',
        content_hl: '',
        db: null,
      }
    },
    components:{
      ThreeColumn,
      LangOpts,
      DownloadWidget
    },
    methods:{
      content_clicked: scrollhelper.content_clicked,
      go_trans(lang){
        var params = {...this.$route.params, 'lang': lang}
        this.$router.push({name: this.$route.name, params: params})
        this.get_pd()
      },
      async get_pd(){
        this.overlay = true
        try {
          const res = await api.get_pd(this.$route.params.lang, this.$route.params.num)
          const file = res
          this.num = file['num']
          this.title = file['title']
          this.content = file['content']
          this.db = file['db']
          if(this.$route.query.hl){
            this.content_hl = highlighthelper.hlBody(this.content, this.$route.query.hl)
          }

          //window.document.title = this.num + ' | HKLII'
          this.pd_exists = true
          await this.$nextTick()
          scrollhelper.scroll_to_anchor(this.$route.hash)
        } catch(err){
          console.error(err)
          this.pd_exists = false
        } finally {
          this.overlay = false
        }
      }
    },
    watch:{
      '$route': function(){
        this.get_pd()
      }
    },
    computed:{
      paths(){
        if (this.pd_exists){
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
            {text: this.db, disabled: false, href: {name: 'other-db', params: {abbr: 'pd'}}},
            {text: this.num, disabled: true}
          ]
        } else {
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          ]
        }
      },
    },
    beforeMount(){
      this.get_pd()
    },
    updated(){
      this.$nextTick(() => {
        scrollhelper.scroll_to_anchor(this.$route.hash)
      })
    },
    metaInfo(){
      return{
        title: this.num + " " + this.title ,
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/_typography.scss';
  
  /***printing***/
  .pd-content{
    @media print{
      font-size: 9pt;
    }
  }

::v-deep {

/***general text setting****/
  /*
  *[style*="#008000"]{
    //color: var(--v-navlink-base) ;
  }*/

  p, font, div, span[lang='ZH-CN'], span[lang='ZH-TW'], span[style*="Courier New"], span[style*="宋体"], .style2,
  .auto-style1, .auto-style2, .auto-style3, .auto-style4, .auto-style5, .auto-style6, .auto-style7, .auto-style8 {
    /*
    span: 3.2
    1: body text
    2: title: "PRACTICE DIRECTION - 2.3"
    3: title : "LEAVE TO APPEAL TO THE COURT OF FINAL APPEAL"
    5: sch title: "STANDARD ORDER GRANTING LEAVE TO APPEAL"
    6: bottom right sign-offs : "Yours faithfully, etc.""
    7: sch text
    8: Annex link (CTPD1)
    */
     font-family: $body-font !important;
  }

  /*p.auto-style4, p.auto-style5, p.auto-style6, span.auto-style3, .title_font2, p.auto-style2>u, p.auto-style3>span.auto-style5, p[align="center"]>u>span.auto-style2,p[align="center"]>b>span.auto-style4 {*/
    // for title colors
    /*p.6 is the title of chinese pd2.3
    span for pd2.1 chi
    title_font2 for pd2.2 chi
    cannot format p.1: CTPD2 title because many content it is also the body text
    p3>span5 PDSL10.3
    p[a=c] u>span2 PDSL 10.1
    */
     /*color: var(--v-navlink-base);
  }*/

 font[color="#008000"]{
    color: var(--v-navlink-base);
  }

  a { 
    @include link-no-underline;
  }

  a.para{ /*paragraph numbers in english*/
    color: var(--v-navlink-base);
  }

  em, blockquote>p.auto-style4,blockquote+p.auto-style4, p.auto-style6>span.auto-style1, p.auto-style6>span.auto-style2, p>span.auto-style3, blockquote>p.auto-style6{ 
    /*em: reset color for PD2.3 eng sch2 italics,
      blcq: reset signoff of PD2.3 chinese
      p>span: PDSL10.3
      blcq > p6: chi PDSL10.2
    */
    color: rgba(0, 0, 0, 0.87);
  }

/*remove underline*/
 p.auto-style3 >u, span.auto-style1.heading>u, p>b>u, p[align="center"]>u, .style6{
   text-decoration: none;
 }

/*****body*****/
  p {
    //display: table-cell;
    line-height:1.55em;
    margin-left:1.5em;
    margin-bottom:0.66em;
  }
  
  blockquote {
    margin-left:1.5em;
    padding-bottom: 0.66em;
  }

  .MsoPlainText > b {
    padding-top: 1em;
    display:inline-block;
  }
  blockquote > p > font, p[align='JUSTIFY']{ /*PD11.3 chi*/
    font-weight: 400;
    font-size: 16px;
    line-height: 1.55em;
    @media print{
       font-size: 10.5pt;
     }
  }
  font[size='4']{/*PD19.2 chi*/
    font-size: 16px;
      @media print{
       font-size: 10.5pt;
     }
  }
  blockquote > p.auto-style2 { /*PD11.3 chi*/
  margin-top: 0px;
  }

  table { /*author*/
    margin-top: 2em;
    margin-bottom: 2em;
  }
  style+table, link+table, .fontsize {
    display: none;  /*remove extra space at top, e.g pd1.1*/
  }
  td.auto-style3 {
    border:none;
    border-bottom: 1px solid var(--v-darkgrey-lighten3);
  }
  td.auto-style3[style*="50%"] { /*remove for PDSL 10.1, pd33 signoff*/
    border-bottom:none;
  }
  
  hr {
    margin-bottom: 1em;
  }

  /*****WAI****/
  #printwai{
    display: none;
  }


  /*****title*****/
  .title_font1, p[align="center"]>b, p[align="center"]>span.auto-style3, p.auto-style3[align="center"]{ /*chinese 1.1 title, CTPD2 title */
    margin-bottom: 0.33em;
    font-size: 17pt;
    line-height: 1.33em;
    color: var(--v-liiblack-base);
     @media print{
       font-size: 10.5pt;
     }
  }
  .heading,.MsoPlainText.heading >b> u, p>i>u,p>b>u, p.auto-style2>u, p.auto-style2, b>span.auto-style1.heading, p.auto-style3>u{ 
    /*english 1.1 h1
      chi pd10.4
      pbu > PDSL10.2
      p.2>u: title for PDSL10.4
      b>span>.head: PDSL10.3
      p.3>u : PDSL 10.2
    */
    font-size: 14pt;
    font-weight: 600; 
    margin-left:0em;
    margin-top:2em;
    text-decoration: none;
    display: inline-block;
      @media print{
       font-size: 10.5pt;
     }
  }

  p+p[align="center"]{  /*sch title spacing at PDSL10.2*/
    margin-top: 3em;
  }
  p[align="center"]+p[align="center"]{ /*remove effect on stacked lines at PDSL10.2*/
    margin-top: 0em;
  }

  p[align="center"].auto-style2{ /*eng PD9.3 title no line break*/
    display: block;
    color: var(--v-navlink-base);
  }
 


  /*****table in pd10.4******/
  table.auto-style3{ 
    padding-left:2em ;
    width:100% !important;
  }
  table.auto-style3>tbody>tr>td{
    border-bottom: 1px solid var(--v-darkgrey-lighten3);
  }
  table.auto-style3>thead>tr>td{
     border-bottom: 1px solid var(--v-darkgrey-lighten3);
  }
  td.auto-style6> p, td.auto-style4> p, td.auto-style3>p, td.auto-style7 >p{
     margin-left: 0.33em;
     margin-top: 0.33em;
     margin-right:0.33em;
  }
 

  /*******table in pd CTPD2*********/
  table.auto-style2{ 
    padding-left:2em ;
    border: none;
  }

  /*******table in pd CTPD1*********/
  td>p.auto-style2{
    font-size: 10pt;
      @media print{
       font-size: 10.5pt;
     }
  }

}
</style>